import {createContext, useContext, useEffect, useState} from 'react';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [displayNotification, setDisplayNotification] = useState(null);

    useEffect(() => {

    }, [displayNotification]);


    return (
        <NotificationContext.Provider value={{ displayNotification, setDisplayNotification }}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => useContext(NotificationContext);
